import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Hook to get the current authenticated user.
 * Optionally signs in anonymously if no user is present.
 * 
 * @param {Object} options - { signInAnonymously: boolean }
 * @returns {[boolean, Object]} [loading, user]
 */
export function useCurrentUser(options = {}) {
  const { signInAnonymously = false } = options;
  const [user, setUser] = useState(() => firebase.auth().currentUser);
  const [loading, setLoading] = useState(!firebase.auth().currentUser);

  useEffect(() => {
    let active = true;
    const auth = firebase.auth();

    const unsubscribe = auth.onAuthStateChanged(async (u) => {
      if (!active) return;

      if (!u && signInAnonymously) {
        setLoading(true);
        try {
          const result = await auth.signInAnonymously();
          if (active) {
            setUser(result.user);
            setLoading(false);
          }
        } catch (err) {
          console.error("Anonymous sign-in error:", err);
          if (active) setLoading(false);
        }
      } else {
        setUser(u);
        setLoading(false);
      }
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, [signInAnonymously]);

  return [loading, user];
}
